export const ModalReducer = (state = {
    register: false,
    buyTurn: false,
    result: false,
    confirm: false,
    auction_submit: false,
    data: {},
    dataToModal: {}
}, action) => {
    switch (action.type) {
        case "SET_SHOW_RESULT_MODAL":
            console.log("modal result to " + action.payload);
            return {
                ...state,
                register: false,
                buyTurn: false,
                auction_submit: false,
                confirm: false,
                result: action.payload
            };
        case "SET_SHOW_BUY_TURN_MODAL":
            console.log("modal buy_turn to " + action.payload);
            return {
                ...state,
                register: false,
                result: false,
                auction_submit: false,
                confirm: false,
                buyTurn: action.payload
            };
        case "SET_SHOW_CONFIRM_MODAL":
            console.log("modal confirm to " + action.payload);
            return {
                ...state,
                register: false,
                result: true,
                auction_submit: false,
                buyTurn: false,
                confirm: action.payload,
            };
        case "SET_SHOW_AUCTION_SUBMIT_MODAL":
            console.log("modal auction_submit to " + action.payload);
            return {
                ...state,
                register: false,
                buyTurn: false,
                result: false,
                confirm: false,
                auction_submit: action.payload,
                data: action.payload ? {} : state.data
            };
        case "SET_DATA_FROM_MODAL":
            console.log("data from modal " + action.payload);
            return { ...state, data: action.payload };
        case "SET_DATA_TO_MODAL":
            console.log("data to modal " + JSON.stringify(action.payload));
            let typeModal = action.payload.type;
            if (typeModal == 'result') {
                return {
                    ...state,
                    register: false,
                    buyTurn: false,
                    auction_submit: false,
                    confirm: false,
                    result: true,
                    dataToModal: action.payload.dataToModal,
                };
            } else if (typeModal == 'confirm') {
                return {
                    ...state,
                    register: false,
                    buyTurn: false,
                    auction_submit: false,
                    result: false,
                    confirm: true,
                    dataToModal: action.payload.dataToModal,
                };
            }
            return state;
        default:
            return state;
    }
}

export default ModalReducer;